{
  "name": "La primera cadena",
  "coins": 0,
  "portCapacity": 40,
  "tiles": [
    {
      "id": "mina",
      "name": "Mina de hierro",
      "kind": "resource",
      "cell": [10, 2],
      "ports": [{ "id": "salida", "kind": "out", "side": "S" }]
    },
    {
      "id": "taller",
      "name": "Taller",
      "kind": "factory",
      "cell": [9, 4],
      "ports": [
        { "id": "entrada", "kind": "in", "side": "W", "index": 3 },
        { "id": "salida", "kind": "out", "side": "E", "index": 3 }
      ]
    },
    {
      "id": "almacen",
      "name": "Almacén de la colonia",
      "kind": "warehouse",
      "cell": [7, 5],
      "ports": [{ "id": "entrada", "kind": "in", "side": "E" }]
    }
  ],
  "orders": ["deliver-50-gears"]
}
